<template>
    <div class="project-container">
        <div class="top-title">
            <h2>云南红河建水县山水田宇阳光玫瑰葡萄园智慧园区项目</h2>
        </div>

        <!-- 证书与描述区 -->
        <el-row :gutter="16" class="main-content">
            <!-- 左侧：数字农业智能驾驶舱 -->
            <el-col :span="8">
                <img :src="dashboardImg" alt="数字农业智能驾驶舱" class="main-img">
            </el-col>

            <!-- 右侧：平台描述 -->
            <el-col :span="14">
                <div class="desc-card">
                    <p>
                        我公司于2022年疫情期间开始实施云南山水田宇阳光玫瑰葡萄园智慧园区项目，该项目有65座连栋温室，占地约600余亩。
                    </p>
                    <p>
                        该项目通过建设环境监测系统、大数据管理系统、迷雾打药系统、轨道机器人监控系统、集控中心大屏系统等，实施了园区的自动化温室调控、流程化农事管理方案，有效缓解人工依赖性强、物料使用不透明、管理方法滞后等痛点。依托集控中心系统，园区实现全流程自动化管理；通过定制化大数据大屏，管理人员可实时掌握全局运营态势。
                    </p>
                    <p>
                        该项目建成后的成果多次被当地电视台等媒体报道”。同时多次吸引其他县区政府部门到当地考察，我公司研发生产的现代农业设备与大数据平台，真正助力山水田宇真正助力山水田宇园区所属企业成为当地龙头企业成为当地龙头企业。
                    </p>
                </div>
            </el-col>
        </el-row>

        <!-- 底部图片展示区 -->
        <div class="image-grid">
            <el-row :gutter="15">
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/yntwo.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司生产迷雾打药机
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/ynthree.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司环境监测系统
                    </p>
                </el-col>
                <el-col :span="8">
                    <img src="@/assets/images/MainTypicalcase/ynfour.png" alt="" class="project-img">
                    <p class="img-p">
                        配备我公司生产轨道机器人监控系统
                    </p>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NingxiaProjectPage',
    data() {
        return {
            dashboardImg: require('@/assets/images/MainTypicalcase/ynone.png')

        }
    }
}
</script>